export type Theme = {
  slug: string;
  name: string;
  title: string;
  description: string;
};

export const themes: Theme[] = [
  {
    slug: "mafia-et-grand-banditisme",
    name: "Mafia & grand banditisme",
    title: "Reportages sur la mafia corse et le grand banditisme",
    description:
      "Enquêtes télévisées sur le milieu corse, les règlements de comptes et la pression mafieuse sur l'économie de l'île.",
  },
  {
    slug: "nature-et-montagne",
    name: "Nature & montagne",
    title: "Documentaires sur la nature en Corse",
    description:
      "Le GR20, les calanques de Piana, la réserve de Scandola : les documentaires consacrés aux paysages corses.",
  },
  {
    slug: "histoire-et-identite",
    name: "Histoire & identité",
    title: "Reportages sur l'histoire et l'identité corse",
    description:
      "De Pasquale Paoli au nationalisme contemporain, les documentaires qui racontent la mémoire de la Corse.",
  },
  {
    slug: "gastronomie-et-terroir",
    name: "Gastronomie & terroir",
    title: "Documentaires sur la gastronomie corse",
    description:
      "Charcuterie, fromages de brebis, vins de Patrimonio : les reportages consacrés au terroir corse.",
  },
  {
    slug: "tourisme-et-societe",
    name: "Tourisme & société",
    title: "Reportages sur le tourisme et la société corse",
    description:
      "Surtourisme, logement, vie insulaire : les enquêtes sur la Corse d'aujourd'hui.",
  },
  {
    slug: "nationalisme-corse",
    name: "Nationalisme corse",
    title: "Nationalisme corse : FLNC, autonomistes et indépendantistes en documentaires",
    description:
      "Que veulent les nationalistes corses ? FLNC, nuits bleues, Aléria 1975, affaire Yvan Colonna, Corsica Libera et autonomie : les reportages et archives qui racontent le mouvement nationaliste, de la clandestinité aux institutions.",
  },

  {
    slug: "politique-corse",
    name: "Politique corse",
    title: "Reportages sur la politique et l'autonomie de la Corse",
    description:
      "Assemblée de Corse, élections territoriales, processus de Beauvau et statut d'autonomie : les documentaires sur la vie politique insulaire.",
  },
  {
    slug: "sport-et-football",
    name: "Sport & football",
    title: "Reportages sur le football corse : SC Bastia, AC Ajaccio, Gazelec",
    description:
      "Sporting Club de Bastia, AC Ajaccio, Gazelec Ajaccio, derbys, ultras et drame de Furiani : les reportages et documentaires consacrés au football et au sport en Corse.",
  },
  {
    slug: "religion-et-confreries",
    name: "Église & confréries",
    title: "Reportages sur l'Église en Corse, les confréries et la foi insulaire",
    description:
      "Diocèse d'Ajaccio, cathédrales et chapelles, confréries, processions de la Semaine sainte, Granitula et chants sacrés : les documentaires consacrés à l'Église et à la religion en Corse.",
  },
  {
    slug: "franc-maconnerie-et-reseaux",
    name: "Franc-maçonnerie & réseaux",
    title: "Reportages sur la franc-maçonnerie en Corse et les réseaux d'influence",
    description:
      "Loges, Grand Orient, réseaux d'influence, marchés publics et pouvoir local : les enquêtes consacrées à la franc-maçonnerie et aux cercles d'influence en Corse.",
  },
  {
    slug: "musique-et-chant-corse",
    name: "Musique & chant corse",
    title: "Chant corse, polyphonies et paghjella : les archives vidéo",
    description:
      "Cantu in paghjella, polyphonies sacrées, chants de lutte et de bergers, Canta u Populu Corsu, A Filetta, I Muvrini : les captations et archives du chant corse, y compris les formats courts.",
  },
  {
    slug: "rallye-et-sport-auto",
    name: "Rallye & sport auto",
    title: "Tour de Corse : le rallye WRC en vidéo",
    description:
      "Le « rallye aux 10 000 virages » depuis 1956 : archives WRC, années groupe B, drames Bettega et Toivonen, victoires de Ragnotti, Auriol, Loeb, et Tour de Corse Historique.",
  },
  {
    slug: "trail-et-outdoor",
    name: "Trail & outdoor",
    title: "Trail en Corse : Restonica Trail et GR20",
    description:
      "Restonica Trail by UTMB, Ultra Trail di Corsica, record du GR20 et raids outdoor : les films de course et documentaires du trail corse, en accès libre.",
  },
  {
    slug: "velo-et-gt20",
    name: "Vélo & GT20",
    title: "Corse à vélo : la GT20, le Tour de Corse cycliste et le BikingMan",
    description:
      "GT20 (Grande Traversée de la Corse à vélo), tour de l'île en bikepacking, cols de Bavella, Vergio et Ospedale, ultra-distance BikingMan Corsica : les films et reportages du vélo corse, en accès libre.",
  },
  {
    slug: "mer-et-plongee",
    name: "Mer & plongée",
    title: "Plongée en Corse : Scandola, épaves, apnée et voile",
    description:
      "Réserve de Scandola, épaves sous-marines dont le B-17 de Calvi, chasse sous-marine, apnée, traversées à la voile : les documentaires et reportages consacrés à la mer corse.",
  },
  {
    slug: "economie-et-entreprises",
    name: "Économie & entreprises",
    title: "Reportages sur l'économie corse, les entreprises et le foncier",
    description:
      "Tissu économique insulaire, artisanat, commerce, immobilier et spéculation foncière, coût de la vie, emploi et précarité : les enquêtes et documentaires consacrés à l'économie de la Corse.",
  },
  {
    slug: "sante-et-social",
    name: "Santé & social",
    title: "Reportages sur la santé et le social en Corse",
    description:
      "Hôpitaux d'Ajaccio et de Bastia, déserts médicaux, urgences, précarité, logement social et grand âge : les reportages consacrés à la santé et aux questions sociales en Corse.",
  },
  {
    slug: "transports-et-mobilites",
    name: "Transports & mobilités",
    title: "Reportages sur les transports en Corse : ferries, train, routes",
    description:
      "Corsica Linea et La Méridionale, continuité territoriale, aéroports, chemins de fer corses et routes territoriales : les documentaires consacrés aux mobilités insulaires.",
  },
  {
    slug: "justice-et-tribunaux",
    name: "Justice & tribunaux",
    title: "Reportages sur la justice en Corse : procès, assises, enquêtes",
    description:
      "Cours d'assises, procès emblématiques, travail des enquêteurs, gendarmerie et centre pénitentiaire de Borgo : les reportages consacrés à la justice en Corse.",
  },
  {
    slug: "agriculture-et-elevage",
    name: "Agriculture & élevage",
    title: "Reportages sur l'agriculture corse, les bergers et l'élevage",
    description:
      "Bergers et transhumance, élevage porcin en châtaigneraie, apiculture, oliveraies de Balagne et agriculture de montagne : les documentaires consacrés au monde agricole corse.",
  },
  {
    slug: "langue-et-education",
    name: "Langue & éducation",
    title: "Reportages sur la langue corse et l'éducation dans l'île",
    description:
      "Lingua corsa, enseignement bilingue, coofficialité, Université de Corse Pasquale Paoli et transmission scolaire : les reportages consacrés à la langue et à l'école en Corse.",
  },
  {
    slug: "incendies-et-catastrophes",
    name: "Incendies & catastrophes",
    title: "Incendie en Corse : feux de forêt et catastrophes en vidéo",
    description:
      "Incendie Corse, feu de forêt, Canadair et pompiers, tempêtes, inondations et sécheresse : les reportages sur les catastrophes naturelles en Corse.",
  },
  {
    slug: "immobilier-et-foncier",
    name: "Immobilier & foncier",
    title: "Immobilier en Corse : foncier, logement et spéculation en vidéo",
    description:
      "Immobilier corse, spéculation foncière, crise du logement, résidences secondaires, arrêté Miot et statut de résident : les enquêtes et débats sur le foncier en Corse.",
  },
  {
    slug: "emigration-et-diaspora",
    name: "Émigration & diaspora",
    title: "Émigration corse et diaspora : reportages sur les Corses du monde",
    description:
      "Départs pour le continent, les colonies et l'Amérique, Corses de Puerto Rico et du Venezuela, retours au village et mémoire de la diaspora : les documentaires sur l'émigration corse.",
  },
  {
    slug: "artisanat-et-savoir-faire",
    name: "Artisanat & savoir-faire",
    title: "Artisanat corse : couteaux, poterie, lutherie et savoir-faire en vidéo",
    description:
      "Route des artisans de Corse, l'artigiani, couteliers, potiers, luthiers, vanniers et ébénistes : les reportages consacrés à l'artisanat corse et à la transmission des savoir-faire.",
  },
];




export function getTheme(slug: string): Theme | undefined {
  return themes.find((t) => t.slug === slug);
}
